import storage from 'libs/storage'
import api from '@/api'
export default {
    state: {
        userInfo: ''
    },
    getters: {
        getUserInfo: state => {
            return state.userInfo;
        },
        getOnlyUserInfo:state=>{
            return state.userInfo.userInfo
        }
    },
    mutations: {
         setUserInfo(state, userInfo) {
            storage.set('userInfo', userInfo);
            state.userInfo = userInfo
        },
        clearUserInfo(state){
            storage.remove('userInfo')
            state.userInfo=''
        }
    },
    actions: {
        getUserInfo({ commit}) {
            return new Promise((resolve, reject) => {
                try {
                    storage.get('userInfo').then((res)=>{
                        if(!res)  {
                            reject(res);
                            return ;
                        }
                        if(res.userInfo){
                            resolve(res)
                            commit('setUserInfo',res)
                            return ;
                        }
                        api.user.getUserInfo(res).then((re)=>{
                            if(+re.status===200){
                                res.userInfo = re.data
                                commit('setUserInfo',res)
                                resolve(res)
                            }else{
                                reject(res);
                            }
                        },(error)=>{
                            reject(error);
                        })


                    })
                } catch (error) {
                    reject(error);
                }
            });
        }
    }
}
